import { render, staticRenderFns } from "./CatalogHeader.vue?vue&type=template&id=ca48e23a&"
import script from "./CatalogHeader.vue?vue&type=script&lang=js&"
export * from "./CatalogHeader.vue?vue&type=script&lang=js&"
import style0 from "./CatalogHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports